import DarkMode from '@mui/icons-material/DarkMode'
import DarkModeOutlined from '@mui/icons-material/DarkModeOutlined'
import LightMode from '@mui/icons-material/LightMode'
import LightModeOutlined from '@mui/icons-material/LightModeOutlined'
import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { useThemeContext } from '@/contexts/theme/themeContext'

export const themeModeSwitchTestId = 'theme-mode-switch'

export const ThemeModeSwitch = () => {
  const { theme, toggleThemeMode } = useThemeContext()
  const {
    palette: { mode }
  } = theme
  const isDarkMode = mode === 'dark'

  return (
    <Stack flexGrow={1} data-testid={themeModeSwitchTestId}>
      <Typography
        variant="caption"
        component="p"
        gutterBottom
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        MODE
      </Typography>
      <ToggleButtonGroup
        color="primary"
        size="small"
        value={mode}
        exclusive
        onChange={toggleThemeMode}
        fullWidth
      >
        <ToggleButton value="light" aria-label="theme-light" sx={{ gap: 0.5 }}>
          {!isDarkMode ? <LightMode /> : <LightModeOutlined />}
          Light
        </ToggleButton>
        <ToggleButton value="dark" aria-label="theme-dark" sx={{ gap: 0.5 }}>
          {isDarkMode ? <DarkMode /> : <DarkModeOutlined />}
          Dark
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  )
}
